module.exports = __webpack_public_path__ + "img/notifications.b1e92a79.svg";